module.exports = __webpack_public_path__ + "img/egld.ba7b6fa5.svg";